import React, { useState, ReactNode } from 'react';
import { DataRefreshContext } from './data-refresh-context';
import { useDataRefresh } from './data-refresh-utils';

export function DataRefreshProvider({ children }: { children: ReactNode }) {
  const [refreshTrigger, setRefreshTrigger] = useState<number>(Date.now());

  const forceRefresh = () => {
    console.log('🔄 Forçando atualização global dos dados...');
    setRefreshTrigger(Date.now());
  };

  return (
    <DataRefreshContext.Provider value={{ forceRefresh, refreshTrigger }}>
      {children}
    </DataRefreshContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { useDataRefresh };